import Head from 'next/head'
import { useTranslation } from 'hooks/useTranslation'
import { OurStory } from 'features/OurStory'
import Script from 'next/script'
const OurStoryPage = () => {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Our Story',
    url: 'https://wefeedraw.com/our-story',
    description:
      "The story of our company is the story of a deep commitment to the well-being of dogs. Discover our incredible founders' journey here.",
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@type': 'WebPage',
            name: 'By Dog Lovers, For Dog Lovers.',
            url: 'https://wefeedraw.com/our-story#our-story-1',
            description: 'This company was founded by my amazing sister, Alissa.',
            about: {
              '@type': 'CreativeWork',
              name: 'By Dog Lovers, For Dog Lovers.',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw',
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg',
                },
              },
            },
          },
        },
        {
          '@type': 'ListItem',
          position: 2,
          item: {
            '@type': 'WebPage',
            name: 'This is Teddy. (He lived to 18.)',
            url: 'https://wefeedraw.com/our-story#our-story-2',
            description:
              'Today, our whole team feeds their family pets these complete + balanced raw meals, and we literally SEE it working for them every day.',
            about: {
              '@type': 'CreativeWork',
              name: 'This is Teddy. (He lived to 18.)',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw',
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg',
                },
              },
            },
          },
        },
        {
          '@type': 'ListItem',
          position: 3,
          item: {
            '@type': 'WebPage',
            name: 'How We Make the Healthiest Dog Food on Earth',
            url: 'https://wefeedraw.com/our-story#our-story-3',
            description: 'Raw is what nature intended.',
            about: {
              '@type': 'CreativeWork',
              name: 'How We Make the Healthiest Dog Food on Earth',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw',
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg',
                },
              },
            },
          },
        },
        {
          '@type': 'ListItem',
          position: 4,
          item: {
            '@type': 'WebPage',
            name: 'Dog Food Has an Ugly History.',
            url: 'https://wefeedraw.com/our-story#our-story-4',
            description:
              'A raw, minimally processed, protein-rich diet is what your dog was meant to eat, and what will help them live more happy, healthy dog years.',
            about: {
              '@type': 'CreativeWork',
              name: 'Dog Food Has an Ugly History.',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw',
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg',
                },
              },
            },
          },
        },
      ],
    },
  }

  const jsonLdString = JSON.stringify(schema)

  return (
    <>
      <Head>
        <title>{t('our-story:page-title')}</title>
        <meta name="title" content={t('our-story:meta-title')} />
        <meta name="description" content={t('our-story:meta-description')} />
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://wefeedraw.com/our-story" />
      </Head>
      <Script
        id="schema-script"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdString }}
      />
      <main>
        <OurStory />
      </main>
    </>
  )
}

export default OurStoryPage
